/**
 * Delete a queue and any pending runs.
 */

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import {
  useDeleteDefaultResourceConfigMutation,
  useDeleteRunQueuesMutation,
} from '../../../generated/graphql';
import {propagateErrorsContext} from '../../../util/errors';
import {Queue} from './queueUtil';

type DeleteQueueDialogProps = {
  queue: Queue | null;
  onClose: () => void;
  onDelete?: () => void;
};

export const DeleteQueueDialog = ({
  queue,
  onClose,
  onDelete,
}: DeleteQueueDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const onClosing = () => {
    setIsDeleting(false);
    onClose();
  };

  const [deleteDefaultResourceConfig] = useDeleteDefaultResourceConfigMutation({
    context: propagateErrorsContext(),
  });

  const queueIDs = queue ? [queue.id] : [];
  const [deleteRunQueue] = useDeleteRunQueuesMutation({
    variables: {queueIDs},
    context: propagateErrorsContext(),
  });

  const onClickDelete = async () => {
    if (!queue) {
      // Should not be possible
      return;
    }
    setIsDeleting(true);
    // TODO: Should we be attempting to stop running agents before deleting?
    // TODO: Should not delete config if other queues are using it
    // TODO: Error handling
    if (queue.defaultResourceConfig?.id) {
      try {
        const defaultResourceConfigIDs = [queue.defaultResourceConfig?.id];
        await deleteDefaultResourceConfig({
          variables: {defaultResourceConfigIDs},
        });
      } catch (e) {
        console.error(e);
      }
    }
    // TODO: Error handling
    await deleteRunQueue();
    if (onDelete) {
      onDelete();
    }
    setIsDeleting(false);
    onClose();
  };

  return (
    <Dialog onClose={onClosing} open={queue != null}>
      <DialogTitle>Are you sure you want to delete this queue?</DialogTitle>
      <DialogContent dividers>
        Are you sure you want to DELETE this queue? All starting or queued runs
        will be removed everywhere. Finished runs from this queue will still be
        available. This action cannot be undone!
      </DialogContent>
      <DialogActions>
        <Button onClick={onClosing} variant="secondary" size="large">
          Cancel
        </Button>
        <Button
          disabled={isDeleting}
          onClick={onClickDelete}
          variant="destructive"
          size="large">
          Delete queue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
